import { actions } from './data'

// Queue
export function addQueue(name, buttonEnabled = false) {
    return actions.queue.setMessages(name, buttonEnabled)
}

export function setQueue(name) {
    return actions.queue.setQueue(name)
}

export function setButtonEnabled(enabled) {
    return actions.queue.setButtonEnabled(enabled)
}

export function setVisibility(visible) {
    return actions.queue.setVisibility(visible)
}

export function buttonClicked() {
    return actions.queue.buttonClicked()
}

// Settings
export function languageChanged(locale) {
    return actions.settings.languageChanged(locale)
}

export function setAscending(ascending) {
    return actions.settings.setAscending(ascending)
}

export function setMaxVisible(max) {
    return actions.settings.setMaxVisible(max)
}

export function showTimeoutBar(show) {
    return actions.settings.showTimeoutBar(show)
}

export function showRequestCount(show) {
    return actions.settings.showRequestCount(show)
}

// Toasts
export function setMessages(motds) {
    return actions.toasts.setMessages(motds)
}

export function addToast(options) {
    return actions.toasts.addToast(options)
}

export function addError(options = {}) {
    return actions.toasts.addError(options)
}

export function addWarning(options = {}) {
    return actions.toasts.addWarning(options)
}

export function addSuccess(options = {}) {
    return actions.toasts.addSuccess(options)
}

export function addInfo(options = {}) {
    return actions.toasts.addInfo(options)
}

export function addMessage(motd, options = {}) {
    return actions.toasts.addMessage(motd, options)
}

export function removeToast(id) {
    return actions.toasts.removeToast(id)
}

export function removeToasts(ids) {
    return actions.toasts.removeToasts(ids)
}

export function reshowNewestMotd() {
    return actions.toasts.reshowNewestMotd()
}

export function motdsChanged(motds) {
    return actions.toasts.motdsChanged(motds)
}



// WEBPACK FOOTER //
// ./src/features/Toaster/actions.js